import { IonText } from '@ionic/react';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { syncTimer } from '../../common/interval';
import { getStateStringAsDate, padLeft } from '../../common/util';
import { ClockingDirection } from '../../models/dms/clocking.model';
import store from '../../store';
import { useAppSelector } from '../../store/hooks';

interface IComponentProps {
  showSeconds?: boolean;
}

const AttendanceTimer: React.FC<IComponentProps> = ({ showSeconds = true }) => {
  const [attendanceHours, setAttendanceHours] = useState('00');
  const [attendanceMinutes, setAttendanceMinutes] = useState('00');
  const [attendanceSeconds, setAttendanceSeconds] = useState('00');

  const { attendanceClocking } = useAppSelector(state => state.technicianClocking);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const { isDemo } = store.getState().app;
        const { attendanceClocking } = store.getState().technicianClocking;

        const endDate = attendanceClocking?.startDateTime ? getStateStringAsDate(attendanceClocking.startDateTime) : new Date();
        let now = new Date();

        // Demo
        if (isDemo) {
          now = moment().set({ hour: 10, minute: 30, second: 32 }).toDate();
        }

        let diff = Math.abs(+endDate - +now);

        let hours = Math.floor(diff / 3.6e6);
        let minutes = Math.floor((diff % 3.6e6) / 6e4);
        let seconds = Math.floor((diff % 6e4) / 1000);

        switch (attendanceClocking?.direction) {
          case ClockingDirection.On:
            setAttendanceHours(padLeft(hours));
            setAttendanceMinutes(padLeft(minutes));
            setAttendanceSeconds(padLeft(seconds));
            break;
          case ClockingDirection.Break:
            now = attendanceClocking?.endDateTime ? getStateStringAsDate(attendanceClocking.endDateTime) : new Date();
            diff = Math.abs(+endDate - +now);

            hours = Math.floor(diff / 3.6e6);
            minutes = Math.floor((diff % 3.6e6) / 6e4);
            seconds = Math.floor((diff % 6e4) / 1000);

            setAttendanceHours(padLeft(hours));
            setAttendanceMinutes(padLeft(minutes));
            setAttendanceSeconds(padLeft(seconds));
            break;
          default:
            setAttendanceHours('00');
            setAttendanceMinutes('00');
            setAttendanceSeconds('00');
            break;
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonText color={attendanceClocking?.direction === ClockingDirection.On ? 'success' : 'warning'} class="ion-text-nowrap ion-align-self-center">
      <h1 className="time-duration ion-no-margin">{attendanceHours}:</h1>
      <h1 className="time-duration ion-no-margin">{attendanceMinutes}</h1>
      {showSeconds && <h1 className="time-duration time-duration-seconds ion-no-margin">{attendanceSeconds}</h1>}
    </IonText>
  );
};

export default AttendanceTimer;